module.exports = __webpack_public_path__ + "static/img/1.df08e3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p1/1.png
// module id = mThw
// module chunks = 1